import { DayOff } from '../type/day-off.type';

export class DaysOff {
  id: string;
  days: DayOff[] = [];

  public filteredByMonth(monthIndex: number): DayOff[] {
    return this.days.filter((day) => day.date.getMonth() === monthIndex);
  }
}
